import {initComparison} from './js/modules/comparison/module.comparison.js';

import {initPackageComponents} from './js/components/resultitem/init.js';

initPackageComponents();


document.addEventListener('DOMContentLoaded', async () => {
  initComparison();
});
